document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector(".link-text.contact-form-show");
  const form = document.querySelector(".contact-form");

  // if (!trigger || !form) return;

  // The clickable area is the whole .link-text.contact-form-show div
  trigger.addEventListener("click", () => {
    toggleForm();
  });

  function toggleForm() {
    trigger.classList.toggle("active");

    if (form.classList.contains("open")) {
      slideUp(form);
    } else {
      slideDown(form);
    }
  }

  function slideDown(el, duration = 400) {
    if (el.classList.contains("animating")) return;
    el.classList.add("animating", "open");

    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") display = "block";
    el.style.display = display;

    const height = el.scrollHeight;
    el.style.overflow = "hidden";
    el.style.height = "0rem";
    el.offsetHeight; // force reflow
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = height + "rem";

    requestAnimationFrame(() => {
      el.classList.remove("animating");
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    });
    // setTimeout(() => {
    //   el.classList.remove("animating");
    //   el.style.removeProperty("height");
    //   el.style.removeProperty("overflow");
    //   el.style.removeProperty("transition");
    // }, duration);
  }

  function slideUp(el, duration = 400) {
    if (el.classList.contains("animating")) return;
    el.classList.add("animating");

    el.style.height = el.scrollHeight + "px";
    el.style.overflow = "hidden";
    el.offsetHeight; // force reflow
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = "0px";

    setTimeout(() => {
      el.classList.remove("animating", "open");
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    }, duration);
  }

  // open trigger Melibo Live chat widget

  // ✅ Close form when clicking other buttons
  document.querySelectorAll('.link-text:not(.contact-form-show)').forEach(btn => {
    btn.addEventListener('click', () => form.classList.contains("open") && (slideUp(form), trigger.classList.remove("active")));
  });

  // open trigger Melibo Live chat widget

  const meliboBtn = document.getElementById('trigger-melibo-chat');

  if (meliboBtn) {
    meliboBtn.addEventListener('click', function () {
      if (window.melibo && typeof window.melibo.openWidget === 'function') {
        window.melibo.openWidget();
      }
    });
  }


});

